/**
 * This is the login routes configuration.
 * Only configure routes in this file.
 * @memberOf Login Module
 * @namespace Login Routes
 */
import loginTemplate from './login.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf Login Module.Login Routes
 * @ngInject
 */
var config = function($stateProvider) {

  /* Create the login state and assign the template and controller. */
  $stateProvider
    .state('login', {
      abstract: true,
      url: '/login',
      template: loginTemplate,
      controller: 'loginController',
      controllerAs: 'loginController'
    });
}

export default config;


// WEBPACK FOOTER //
// ./src/login/login.route.js